import { gsap } from "gsap";
import { CSSRulePlugin } from "gsap/CSSRulePlugin";
import { EaselPlugin } from "gsap/EaselPlugin";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { init } from "./scenes";
import {ismobile} from "./utils"
import imageFade from "./imagefade";

export function startHeader(isMobile = false){
    if (!isMobile){
        desk();
    } else {
        mobile();
    }
}

let initCopyMove = function(){
    $(document).mousemove(function(event){
        var xPos = (event.clientX/$(window).width())-0.5;
        var yPos = (event.clientY/$(window).height())-0.5;
        gsap.to('.header__copy',{rotationY: xPos * 50, rotationX: yPos * 50, ease: "power1.out"});
    });
}

function desk(){
    
    let tl = gsap.timeline();

    tl.fromTo('.header__espolon, .header__mask-2',{y:100, opacity:0}, {y:0, opacity:1, duration:0.1, ease: "power1.out"});
    tl.fromTo('.header__paloma, .header__mask',{y:100, opacity:0}, {y:0, opacity:1, duration:0.2, ease: "power1.out"});
    tl.fromTo('.header__flowerright',{x:-200, opacity:0}, {x:0, opacity:1, duration:0.4, ease: "power1.out"},"-=0.4");
    tl.fromTo('.header__flowerleft',{x:200, opacity:0}, {x:0, opacity:1, duration:0.4, ease: "power1.out"},"-=0.4");
   // tl.fromTo('.header__corner-right',{x:200, opacity:0}, {x:0, opacity:1, duration:0.4, ease: "power1.out"},"-=0.4");
    tl.fromTo('.header__ray',{opacity:0}, {opacity:1, duration:0.4, ease: "power1.out"});
    tl.fromTo('.header-logos',{y:-100, opacity:0}, {y:0, opacity:1, duration:0.4, ease: "power1.out"});

    if (ismobile()){
        tl.set('.header__calavera1',{x:"+=50", scale:0.7});
    } else{
        tl.set('.header__calavera1',{x:"+=70", y: "+=50", scale:0.7});
    }
   
    tl.to('.header__calavera1',{x:0, y:0, scale:1, duration: 25});
    tl.to('.header__calavera1',{opacity:1, duration: 1.5}, "-=25");
  
  
    if (ismobile()){
        tl.set('.header__calavera2',{x:"+=80", y:"+=40", scale:0.7}, "-=25");
    } else{
        tl.set('.header__calavera2',{x:"+=80", y:"+=100", scale:0.7}, "-=25");
    }
    
    tl.to('.header__calavera2',{x:0, y:0, scale:1, duration: 25}, "-=25");
    tl.to('.header__calavera2',{opacity:1, duration: 1.5}, "-=25");

    if (ismobile()){
        tl.set('.header__calavera3',{x:"-=80", y:"+=30", scale:0.7}, "-=25");
    } else{ 
        tl.set('.header__calavera3',{x:"-=80", y:"+=70", scale:0.7}, "-=25");        
    }

    tl.to('.header__calavera3',{x:0, y:0, scale:1, duration: 25}, "-=25");
    tl.to('.header__calavera3',{opacity: 1, duration: 1.5}, "-=25");

    if (ismobile()){
        tl.set('.header__calavera4',{x: "-=40", y:"+=50", scale:0.7},"-=25");
    } else{ 
        tl.set('.header__calavera4',{x: "-=50", y:"+=30", scale:0.7},"-=25");   
    }

    tl.to('.header__calavera4',{opacity: 1, duration: 1.5}, "-=25");
    tl.to('.header__calavera4',{x:0,y: 0,  scale:1, duration: 25}, "-=25");
    tl.fromTo('.header__letter, .header__logo-espolon',{opacity:0}, {opacity:1, duration:0.01, stagger:0.1}, "-=25");
    tl.to('.header__figure',{opacity:1, duration: 0.2, onComplete: function(){
       imageFade();
    }}, "-=25");

}   

function mobile(){
   desk();
}